// extracted by mini-css-extract-plugin
export default {"socWrapper":"Soc_socWrapper__iEPgT","followBox":"Soc_followBox__Nec9o","followSoc":"Soc_followSoc__HJs7P","followSocActive":"Soc_followSocActive__BNkmj"};